/**
 * MobileLeave.jsx — fullscreen mobile mirror of ApplyLeave for /m/leave route.
 */
import React from 'react';
import ApplyLeave from '../hr/ApplyLeave';

export default function MobileLeave() {
  return (
    <div data-testid="mobile-leave-page">
      <ApplyLeave compact />
    </div>
  );
}
